<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import ReportPageHeader from "@/components/report-page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
import Input from "@/components/c-input";
import Button from "@/components/c-button";
import moment from 'moment'
import { manageReportService } from "../../../../services/managements/reports/report.service.js";


/* eslint-disable no-console */
export default {
  page: {
    title: "Income & Expense Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    ReportPageHeader,
    Button,
    Input,
    Select, 
  },
  data() {
    return {
      title: "Income & Expense Report",
      data: [],
      projects: {},
      types: [
        {id: "all_income", label: 'ចំណូល(ការប្រើប្រាស់ថ្មី)'},
        {id: "old_income", label: 'ចំណូល(បំណុលចាស់)'},
        {id: "deposit", label: 'ចំណូល(អតិថិជនបង់ប្រាក់ទុកមុន)'},
        {id: "income", label: 'ចំណូល(ផ្សេងៗ)'},
        {id: "expense", label: 'ចំណាយ'},
      ],

      dataProjectId: 0,
      dataPropertyId: 0,
      dataMonth: (moment().month() + 1) <10 ? '0'+(moment().month() + 1): (moment().month() + 1),
      dataYear: moment().year(),
      dataStartDate: '',
      dataEndDate: '',
      dataTypeId: 0,
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadReport();
    
  },
  methods: {
    
    loadReport: function() {
      let data = '?project_id='+this.dataProjectId+
        '&start_date='+this.dataStartDate+
        '&end_date='+this.dataEndDate
      
      manageReportService.getIncomeExpenseReport(data)
        .then(response => {
          console.log(response);
          this.data = response.data;
          this.dataStartDate = this.data.date.start_date
          this.dataEndDate = this.data.date.end_date
        });
        
    },
    submitSearch: function() {
      this.loadReport();
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    moment: function () {
      return moment();
    },
    formatCurrency(value) {
      if(value == 0 ){
        return '$0.00';
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
  
    print() {
      window.print();
    },
    total(column_name, data){
      if(data){
        let total = 0;
        data.map(function(item){
            total += item[column_name];
        });

        return total;
      }
     
     
    }
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="'របាយការណ៍ចំណូល និងចំណាយ'" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row search-area">
              
              <div class="col-sm-2">
                <label>គម្រោង</label>
                <Select
                  :id="'id'"
                  :text="'name'"
                  :editable="true"
                  :list="{data: this.data.projects}"
                  v-model="dataProjectId"
                /> 
              </div>
              <div class="col-sm-2">
                <!-- <label>ខែ</label>
                <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: this.data.date.months}"
                  v-model="dataMonth"
                />  -->
                 <Input
                    :type="'date'"
                    :id="'invoice_date'"
                    v-model="dataStartDate"
                    :label="'manage.start-date'"
                  />
              </div>
              
               <div class="col-sm-2">
                 <!-- <label>ឆ្នាំ</label>
                <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: this.data.date.years}"
                  v-model="dataYear"
                />  -->
                <Input
                    :type="'date'"
                    :id="'invoice_date'"
                    v-model="dataEndDate"
                    :label="'manage.end-date'"
                  />
              </div>
              <div class="col-sm-2">
                 <label>ប្រភេទ</label>
                <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: this.types}"
                  v-model="dataTypeId"
                /> 
              </div>
              <div class="col-sm-2 pt-2">
                <br>
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div>
          </div>
          <div class="col dblack box-a4l">
            <ReportPageHeader
              :title="'របាយការណ៍ចំណូល និងចំណាយ'"
              :titleDate="this.data.date?(this.data.date.start_date_kh + ' ដល់ ' + this.data.date.end_date_kh):''"
            />
            <br>
            <div v-if="(this.dataTypeId == 'all_income' || this.dataTypeId == '')">
              <section class="title p-3">
                <center>
                  <h5 class="khm">ចំណូល(ការប្រើប្រាស់ថ្មី) ប្រចាំខែ{{this.data.date.current}}</h5>
                </center>
              </section>
              <div v-if="this.data.all_income">
              <table class="content-general h8 project-sumary-table report-table" width="100%">
                
                  <tr class="thead">
                    <th class="text-center">លរ</th>
                    <th class="text-center">លេខវិក័យប័ត្រ</th>
                    <th class="text-center">បន្ទប់</th>
                    <th class="text-center">ទូទាត់ដោយ</th>
                    <th class="text-center">លុយសរុប</th>
                    <th class="text-center">ជំពាក់</th>
                    <th class="text-center">កាត់កងបង់ទុកមុន</th>
                    <th class="text-center">បង់ជាក់ស្ដែង</th>
                    <th class="text-center">សាច់ប្រាក់</th>
                    <th class="text-center">ធនាគារ</th>
                    <th class="text-center">សែក</th>
                  </tr>
                
                <tbody>
                  <tr  v-for="(list, index) in data.all_income" :key="index">
                    <td>{{index+1}}</td>
                    <td>{{list.invoice_code}}</td>
                    <td>{{list.property_code}}</td>
                    <td>{{list.user_name}}</td>
                    <td>{{formatCurrency(list.total_amount)}}</td>
                    <td>{{formatCurrency(list.debt_amount)}}</td>
                    <td>{{formatCurrency(list.deposit_amount)}}</td>
                    <td>{{formatCurrency(list.total_paid_amount)}}</td>
                    <td>{{formatCurrency(list.cash_amount)}}</td>
                    <td>{{formatCurrency(list.bank_amount)}}</td>
                    <td>{{formatCurrency(list.cheque_amount)}}</td>
                  </tr>
                  <tr class="bg-warning">
                    <td class="text-end" colspan="4">សរុប</td>
                    <td>{{formatCurrency(total('total_amount', this.data.all_income))}}</td>
                    <td>{{formatCurrency(total('debt_amount', this.data.all_income))}}</td>
                    <td>{{formatCurrency(total('deposit_amount', this.data.all_income))}}</td>
                    <td>{{formatCurrency(total('total_paid_amount', this.data.all_income))}}</td>
                    <td>{{formatCurrency(total('cash_amount', this.data.all_income))}}</td>
                    <td>{{formatCurrency(total('bank_amount', this.data.all_income))}}</td>
                    <td>{{formatCurrency(total('cheque_amount', this.data.all_income))}}</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
            <div v-if="(this.dataTypeId == 'old_income' || this.dataTypeId == '')">
              <section class="title p-3">
                <center>
                  <h5 class="khm">ចំណូល(បំណុលចាស់) គិតចាប់ពី{{this.data.date.start_date_kh + ' ដល់ ' + this.data.date.end_date_kh}}</h5>
                </center>
              </section>
              <div v-if="this.data.old_income">
              <table class="content-general h8 project-sumary-table report-table" width="100%">
                
                  <tr class="thead">
                    <th class="text-center">លរ</th>
                    <th class="text-center">លេខវិក័យប័ត្រ</th>
                    <th class="text-center">បន្ទប់</th>
                    <th class="text-center">ទូទាត់ដោយ</th>
                    <th class="text-center">លុយសរុប</th>
                    <th class="text-center">ជំពាក់</th>
                    <th class="text-center">កាត់កងបង់ទុកមុន</th>
                    <th class="text-center">បង់ជាក់ស្ដែង</th>
                    <th class="text-center">សាច់ប្រាក់</th>
                    <th class="text-center">ធនាគារ</th>
                    <th class="text-center">សែក</th>
                  </tr>
                
                <tbody>
                  <tr  v-for="(list, index) in data.old_income" :key="index">
                    <td>{{index+1}}</td>
                    <td>{{list.invoice_code}}</td>
                    <td>{{list.property_code}}</td>
                    <td>{{list.user_name}}</td>
                    <td>{{formatCurrency(list.total_amount)}}</td>
                    <td>{{formatCurrency(list.debt_amount)}}</td>
                    <td>{{formatCurrency(list.deposit_amount)}}</td>
                    <td>{{formatCurrency(list.total_paid_amount)}}</td>
                    <td>{{formatCurrency(list.cash_amount)}}</td>
                    <td>{{formatCurrency(list.bank_amount)}}</td>
                    <td>{{formatCurrency(list.cheque_amount)}}</td>
                  </tr>
                  <tr class="bg-warning">
                    <td class="text-end" colspan="4">សរុប</td>
                    <td>{{formatCurrency(total('total_amount', this.data.old_income))}}</td>
                    <td>{{formatCurrency(total('debt_amount', this.data.old_income))}}</td>
                    <td>{{formatCurrency(total('deposit_amount', this.data.old_income))}}</td>
                    <td>{{formatCurrency(total('total_paid_amount', this.data.old_income))}}</td>
                    <td>{{formatCurrency(total('cash_amount', this.data.old_income))}}</td>
                    <td>{{formatCurrency(total('bank_amount', this.data.old_income))}}</td>
                    <td>{{formatCurrency(total('cheque_amount', this.data.old_income))}}</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>

            <div v-if="(this.dataTypeId == 'deposit' || this.dataTypeId == '')">
             <section class="title p-3">
              <center>
                <h5 class="khm">ចំណូលអតិថិជនបង់ប្រាក់ទុកមុន គិតចាប់ពី{{this.data.date.start_date_kh + ' ដល់ ' + this.data.date.end_date_kh}}</h5>
              </center>
            </section>
            <div v-if="this.data.deposit">
             <table class="content-general h8 project-sumary-table report-table" width="100%">
              
                <tr class="thead">
                  <th class="text-center">លរ</th>
                  <th class="text-center">លេខវិក័យប័ត្រ</th>
                  <th class="text-center">ឈ្មោះអតិថិជន</th>
                  <th class="text-center">ទូទាត់ដោយ</th>
                  <th class="text-center">លុយសរុប</th>
                  <th class="text-center">បង់ប្រាក់តាមរយៈ</th>
                </tr>
              
               <tbody>
                <tr  v-for="(list, index) in data.deposit" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{list.id}}</td>
                  <td>{{list.customer_name}}</td>
                  <td>{{list.user_name}}</td>
                  <td>{{formatCurrency(list.total_amount)}}</td>
                  <td>{{ list.payment_method }}</td>
                </tr>
                <tr class="bg-warning">
                  <td class="text-end" colspan="4">សរុប</td>
                   <td>{{formatCurrency(total('total_amount', this.data.deposit))}}</td>
                   <td></td>
                </tr>
               </tbody>
             </table>
            </div>
            </div>

            <div v-if="(this.dataTypeId == 'income' || this.dataTypeId == '')">
              <section class="title p-3">
                <center>
                  <h5 class="khm">ចំណូលផ្សេងៗ គិតចាប់ពី{{this.data.date.start_date_kh + ' ដល់ ' + this.data.date.end_date_kh}}</h5>
                </center>
              </section>
              <div v-if="this.data.income">
              <table class="content-general h8 project-sumary-table report-table" width="100%">
                
                  <tr class="thead">
                    <th class="text-center">លរ</th>
                    <th class="text-center">កាលបរិច្ឆេទ</th>
                    <th class="text-center">ទូទាត់ដោយ</th>
                    <th class="text-center">រាយនាមចំណាយ</th>
                    <th class="text-center">ចំណាយសរុប</th>
                    <th class="text-center">សាច់ប្រាក់</th>
                    <th class="text-center">ធនាគារ</th>
                    <th class="text-center">សែក</th>
                  </tr>
                <tbody>
                  <tr  v-for="(list, index) in data.income" :key="index">
                    <td>{{index+1}}</td>
                    <td>{{list.income_date}}</td>
                    <td>{{list.user_name}}</td>
                    <td>{{list.name}}</td>
                    <td>{{formatCurrency(list.total_amount)}}</td>
                    <td>{{formatCurrency(list.cash_amount)}}</td>
                    <td>{{formatCurrency(list.bank_amount)}}</td>
                    <td>{{formatCurrency(list.cheque_amount)}}</td>
                  </tr>
                  <tr class="bg-warning">
                    <td class="text-end" colspan="4">សរុប</td>
                    <td>{{formatCurrency(total('total_amount', this.data.income))}}</td>
                    <td>{{formatCurrency(total('cash_amount', this.data.income))}}</td>
                    <td>{{formatCurrency(total('bank_amount', this.data.income))}}</td>
                    <td>{{formatCurrency(total('cheque_amount', this.data.income))}}</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
            <div v-if="(this.dataTypeId == 'expense' || this.dataTypeId == '')">
              <section class="title p-3">
                <center>
                  <h5 class="khm">ចំណាយគិតចាប់ពី{{this.data.date.start_date_kh + ' ដល់ ' + this.data.date.end_date_kh}}</h5>
                </center>
              </section>
              <div v-if="this.data.expense">
                <table class="content-general h8 project-sumary-table report-table" width="100%">
                
                  <tr class="thead">
                    <th class="text-center">លរ</th>
                    <th class="text-center">កាលបរិច្ឆេទ</th>
                    <th class="text-center">ទូទាត់ដោយ</th>
                    <th class="text-center">រាយនាមចំណាយ</th>
                    <th class="text-center">ចំណាយសរុប</th>
                    <th class="text-center">សាច់ប្រាក់</th>
                    <th class="text-center">ធនាគារ</th>
                    <th class="text-center">សែក</th>
                  </tr>
                <tbody>
                  <tr  v-for="(list, index) in data.expense" :key="index">
                    <td>{{index+1}}</td>
                    <td>{{list.expense_date}}</td>
                    <td>{{list.user_name}}</td>
                    <td>{{list.name}}</td>
                    <td>{{formatCurrency(list.total_amount)}}</td>
                    <td>{{formatCurrency(list.cash_amount)}}</td>
                    <td>{{formatCurrency(list.bank_amount)}}</td>
                    <td>{{formatCurrency(list.cheque_amount)}}</td>
                  </tr>
                  <tr class="bg-warning">
                    <td class="text-end" colspan="4">សរុប</td>
                    <td>{{formatCurrency(total('total_amount', this.data.expense))}}</td>
                    <td>{{formatCurrency(total('cash_amount', this.data.expense))}}</td>
                    <td>{{formatCurrency(total('bank_amount', this.data.expense))}}</td>
                    <td>{{formatCurrency(total('cheque_amount', this.data.expense))}}</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col text-center">
                <p>ឯកភាព និងទទួលស្គាលើដោយ <br> ហត្ថលេខា</p>
                <br><br>
                <p>លោកនាយកក្រុមហ៊ុន</p>
              </div>
              <div class="col text-center">
                <p>ត្រួតពិនិត្យដោយ <br> ហត្ថលេខា</p>
                <br><br>
                <p>អ្នកគ្រប់គ្រងទូទៅ</p>
              </div>
              <div class="col text-center">
                <p>ត្រួតពិនិត្យដោយ <br> ហត្ថលេខា</p>
                <br><br>
                <p>ជំនួយការអ្នកគ្រប់គ្រង</p>
              </div>
              <div class="col text-center">
                <p>ត្រួតពិនិត្យដោយ <br> ហត្ថលេខា</p>
                <br><br>
                <p>បុគ្គលិក</p>
              </div>
            </div>
            <br>
          </div>  
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>